/**
 * Formats a number as a currency string in British Pounds (£) with two decimal places.
 *
 * @param value - The numeric value to format as currency. If not provided or not a number, defaults to '£0.00'.
 * @returns The formatted currency string in the format '£#,##0.00'.
 *
 * @example
 * formatCurrency(1234.5); // returns '£1,234.50'
 * formatCurrency(); // returns '£0.00'
 */
export const formatCurrency = (value?: number) => {
  if (typeof value !== 'number') return '£0.00';
  return `£${value.toLocaleString('en-GB', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  })}`;
};
